import { Select, MenuItem, InputLabel, SelectChangeEvent } from "@mui/material";
import DropDownArrow from "../../icons/DropDownArrow";
import style from "./DropDown.module.css";
import FormHelperText from "@mui/material/FormHelperText";
import React from "react";

interface DropDownPropsDI {
  items: Array<{ value: number | string; text: string }>;
  onChange?: (event: SelectChangeEvent<string | number | (string | number)[]>) => void;
  value?: string | number | (string | number)[]; // שינוי ל-undefined
  id?: string;
  labelId?: string;
  errorString?: string;
  hasError?: boolean;
  changeOpen?: () => void;
  open?: boolean;
  ariaLabel: string;
}

const DropDown: React.FC<DropDownPropsDI> = (props) => {
  return (
    <React.Fragment>
      <InputLabel
        className={style.dropDownAccessability}
        id={`accessibility_DropDown_${props.labelId}`}
      >
        {props.ariaLabel + (props.hasError ? " " + props.errorString : "")}
      </InputLabel>
      <Select
                      variant="standard"
        error={props.hasError}
        labelId={`accessibility_DropDown_${props.labelId}`}
        id={props.id}
        open={props.open ? props.open : undefined}
        multiple={Array.isArray(props.value) ? true : false}
        onChange={props.onChange}
        onClick={props.changeOpen}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200,
              paddingLeft: 30,
              paddingRight: 30,
            },
          },
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        }}
        className={`${style.select} custom-text-field`} 
        IconComponent={() => {
          return (
            <DropDownArrow
              style={{
                position: "absolute",
                left: "0px",
                pointerEvents: "none",
              }}
            />
          );
        }}
        value={props.value}
      >
        {props.items.map((item, i) => {
          return (
            <MenuItem
              key={i}
              classes={{ root: style.select__item }}
              value={item.value}
            >
              {item.text}
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText className={style.error}>
        {props.hasError && props.errorString}
      </FormHelperText>
    </React.Fragment>
  );
};

export default DropDown;
